import React, { useContext } from 'react'
import AnTimeField from '../../../../components/DateTime/TimeField'

import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { EPCRContext } from '../EPCR'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import { InputAdornment } from '@mui/material'
import ScheduleIcon from '@mui/icons-material/Schedule'

const ResponseTimeComponent = ({ time, field, label }) => {
  const { handleChange } = useContext(EPCRContext)
  return (
    <Grid item xs={6} lg={3}>
      <AnTimeField
        time={time}
        label={label}
        onChange={(newTime) =>
          handleChange({
            moduleName: 'incident',
            field,
            value: newTime,
          })
        }
        InputProps={{
          endAdornment: !time && (
            <InputAdornment position="end">
              <ScheduleIcon
                onClick={() =>
                  handleChange({
                    moduleName: 'incident',
                    field,
                    value: new Date(),
                  })
                }
                sx={{ cursor: 'pointer' }}
              />
            </InputAdornment>
          ),
        }}
      />
    </Grid>
  )
}

const ResponseTimes = ({}) => {
  const { formValues } = useContext(EPCRContext)
  return (
    <EPCRCard>
      <Typography variant="title3">Response Times</Typography>
      <Grid container spacing={2}>
        <ResponseTimeComponent
          time={formValues?.incident?.callTime}
          label="Call Received"
          field="callTime"
        />
        <ResponseTimeComponent
          time={formValues?.incident?.dispatchTime}
          label="Dispatched"
          field="dispatchTime"
        />
        <ResponseTimeComponent
          time={formValues?.incident?.atSceneTime}
          label="Arrive Scene"
          field="atSceneTime"
        />
        <ResponseTimeComponent
          time={formValues?.incident?.patientSideTime}
          label="With Patient"
          field="patientSideTime"
        />
        <ResponseTimeComponent
          time={formValues?.incident?.leaveSceneTime}
          label="Leave Scene"
          field="leaveSceneTime"
        />
        <ResponseTimeComponent
          time={formValues?.incident?.arriveHospitalTime}
          label="Arrive Hospital"
          field="arriveHospitalTime"
        />
        <ResponseTimeComponent
          time={formValues?.incident?.patientHandoverTime}
          label="Patient Handover"
          field="patientHandoverTime"
        />
        <ResponseTimeComponent
          time={formValues?.incident?.clearTime}
          label="Clear"
          field="clearTime"
        />
      </Grid>
    </EPCRCard>
  )
}

export default ResponseTimes
